<template>
  <el-form-item
    :label="label"
    class="action-type"
    :prop="prop"
    :rules="rules"
  >
    <el-select
      v-model="actionType"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      :clearable="false"
      :filterable="false"
      :filter-method="filter"
    >
      <el-option label="" value="" />
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
        <span style="float: left">{{item.label}}</span>
        <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{item.value}}</span> -->
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {},
  model: {
    event: 'change'
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: String,
    placeholder: {
      type: String,
      default: ''
    },
    prop: {
      type: String,
      default: 'action_type'
    },
    mode: {
      type: String,
      default: 'all'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      options: [],
      optionsOriginal: []
    }
  },
  computed: {
    actionType: {
      get () {
        return this.value
      },
      set (actionType) {
        this.$emit('change', actionType)
        this.options = this.optionsOriginal
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'change'))
          }
        }
        return rules
      }
    }
  },
  async mounted () {
    var placeholderName
    var displayMode = this.mode

    if (displayMode === 'flightAction') {
      placeholderName = '着離陸区分'
    }
    if (displayMode === 'hangarUsage') {
      placeholderName = '入出庫区分'
    }
    if (displayMode === 'all') {
      placeholderName = '着離陸・入出庫区分'
    }
    if (displayMode === 'normal') {
      placeholderName = this.placeholder
    }
    this.placeholder = placeholderName

    var actionTypeList = []

    if (displayMode === 'flightAction') {
      actionTypeList = ['1', '8']
    }
    if (displayMode === 'hangarUsage') {
      actionTypeList = ['2', '4']
    }
    if (displayMode === 'all' || displayMode === 'normal') {
      actionTypeList = ['1', '2', '4', '8']
    }

    const actionType = await this.loadCode()
    const actionTypeSet = actionType.map(function (index, array) {
      return { value: index.code_value, label: index.code_explanation }
    })

    var list = []
    for (let i = 0; i < actionTypeSet.length; i++) {
      if (actionTypeList.includes(actionTypeSet[i].value)) {
        list.push(actionTypeSet[i])
      }
    }

    this.options = list
    this.optionsOriginal = list
  },
  methods: {
    async loadCode () {
      if (this.initialize) {
        await this.$axios
          .get('/code-master', { params: { code_id: 'ACTION_TYPE' } })
          .then((res) => {
            sessionStorage.setItem('actionType', JSON.stringify(res.data.list))
          })
          .catch((e) => {
            console.log(e)
          })
      }
      return JSON.parse(sessionStorage.getItem('actionType'))
    },
    filter (a) {
      this.options = this.optionsOriginal.filter((x) => {
        return x.value.toLowerCase().indexOf(a.toLowerCase()) === 0 || x.label.toLowerCase().indexOf(a.toLowerCase()) === 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.action-type {
  ::v-deep .el-form-item__content {
    width: 13em;
  }
}
.el-select-dropdown__item span {
  padding-left: 5px;
  padding-right: 5px;
}

</style>
